const getLinks = (t: any) => [
  {
    href: '#about',
    name: t('Navigation.About'),
  },
  {
    href: '#experience',
    name: t('Navigation.Experience'),
  },
  {
    href: '#work',
    name: t('Navigation.Work'),
  },
  {
    href: '#contact',
    name: t('Navigation.Contact'),
  },
];

export default getLinks;
